module.exports = __webpack_public_path__ + "fonts/MaterialIcons-Regular.1811d38.woff";